<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ year }} Lead Gen Model</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" v-b-toggle.filters>
            <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
              <span class="btn-inner--text">Filters</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <observed-upgrade-overlay :title="year + ' Lead Gen Model'" :upgradeImg="'overlays/lead-gen-model.png'" :placeholderImg="'placeholders/lead-gen-model.png'" v-if="!subscribed"></observed-upgrade-overlay>
      <div v-else>
        <loading-panel v-if="loading"></loading-panel>
        <div v-else id="leadgen-model">
          <div class="text-right mb-3">
            <userpilot-flow :id="'1670595264iIzd1897'" :variant="'neutral'"></userpilot-flow>
          </div>
          <b-collapse id="filters">
            <b-card>
              <base-input label="Year" label-for="yearInput">
                <el-select v-model="year">
                  <el-option v-for="year in years"
                             :key="year.label"
                             :label="year.label"
                             :value="year.value">
                  </el-option>
                </el-select>
              </base-input>
            </b-card>
          </b-collapse>
          <b-card-group deck>
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3 class="mb-0 mt-2">Database</h3>
                  <userpilot-flow :id="'1670595698lVwf0506'" :variant="'outline-primary'"></userpilot-flow>
                </div>
              </b-card-header>
              <b-card-body>
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    What is the current size of your database?
                    <base-input class="float-right w-25 text-right mb-0"
                                type="number"
                                min="0"
                                v-model="databaseForm.size">
                    </base-input>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    How many sales came from Database over the past 12 months?
                    <base-input class="float-right w-25 text-right mb-0"
                                type="number"
                                min="0"
                                v-model="databaseForm.sales_count">
                    </base-input>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Current Database Conversion Ratio.
                    <span class="float-right w-25 text-right">{{ (conversion_ratio * 100).toFixed(2) }}%</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    How many sales do you desire from your database in {{ year }}
                    <base-input class="float-right w-25 text-right"
                                type="number"
                                min="0"
                                v-model="databaseForm.desired_sales">
                    </base-input>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    With Current Conversion Ratio, This is how many people you will need in your database
                    <span class="float-right w-25 text-right">{{ (databaseForm.desired_sales / (databaseForm.sales_count / databaseForm.size).toFixed(4)).toFixed() }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    I Want to increase my database conversion ratio to...
                    <base-input class="float-right w-25 text-right"
                                type="number"
                                min="0"
                                step="0.01"
                                input-group-classes="input-group-merge"
                                appendIcon="fas fa-percent"
                                v-model="databaseForm.increased_conversion_ratio">
                    </base-input>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    With New Conversion Ratio, This is how many people you will need in your database
                    <span class="float-right w-25 text-right">{{ (databaseForm.desired_sales / (databaseForm.increased_conversion_ratio / 100).toFixed(4)).toFixed() }}</span>
                  </b-list-group-item>
                </b-list-group>
                <b-button size="sm" variant="primary" @click="saveDatabase" class="float-right mt-4">Save Database</b-button>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h3 class="mb-0 mt-2">What will your top 5 lead sources be?</h3>
                  <userpilot-flow :id="'1670597170pXex103'" :variant="'outline-primary'"></userpilot-flow>
                </div>
              </b-card-header>
              <div class="p-3">
                <b-form @submit.prevent="addSource" inline>
                  <label class="sr-only" for="touchpoint">Touchpoint</label>
                  <base-input input-classes="form-control-sm"
                              class="mb-2 mr-sm-2"
                              placeholder="Source"
                              v-model="sourceForm.source">
                  </base-input>
                  <label class="sr-only" for="total_closings">Total Closings</label>
                  <base-input input-classes="form-control-sm"
                              type="number"
                              min="0"
                              class="mb-2 mr-sm-2"
                              placeholder="How Many Sales in the next year?"
                              v-b-tooltip.hover 
                              title="How many annual closings will come from this source?"
                              v-model="sourceForm.total_closings">
                  </base-input>
                  <b-button size="sm" class="mb-2 mr-sm-2" variant="primary" @click="addSources">Add Lead Source</b-button>
                </b-form>
              </div>
              <b-table responsive small :items="sources" :fields="sourcesFields" :per-page="perPage" :current-page="currentPage" id="sources" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" foot-clone>
                <template #cell(percent_of_business)="data">
                  {{ (data.item.total_closings / closedUnits * 100).toFixed(2) }}%
                </template>
                <template #cell(actions)="data">
                  <base-button size="sm" @click="handleSourceDelete(data)" variant="danger"><i class="fas fa-trash"></i> Delete</base-button>
                </template>
                <!-- Footer -->
                <template #foot(source)="data">
                  Totals:
                </template>
                <template #foot(total_closings)="data">
                  {{ sumTotalClosings }}
                </template>
                <template #foot(percent_of_business)="data">
                  <span :class="{'text-danger':(totalPercentOfBusiness > 100)}">{{ totalPercentOfBusiness.toFixed(2) }}%</span>
                </template>
              </b-table>
              <div class="d-flex justify-content-center mt-3" id="pagination">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="sources"></b-pagination>
              </div>
            </b-card>
          </b-card-group>
          <b-row>
            <b-col>
              <b-card no-body>
                <b-card-header>
                  <div class="d-flex justify-content-between">
                    <h3 class="mb-0">How will you communicate with your database?</h3>
                    <userpilot-flow :id="'1670597370eIpf8121'" :variant="'outline-primary'"></userpilot-flow>
                  </div>
                </b-card-header>
                <b-card-body>
                  <b-form @submit.prevent="add" inline>
                    <label class="sr-only" for="touchpoint">Touchpoint</label>
                    <base-input input-classes="form-control-sm"
                                class="mb-2 mr-sm-2"
                                placeholder="Touchpoint"
                                v-model="touchpointForm.touchpoint">
                    </base-input>
                    <label class="sr-only" for="date">Date</label>
                    <base-input input-classes="form-control-sm"
                                class="mb-2 mr-sm-2"
                                type="date"
                                v-model="touchpointForm.date">
                    </base-input>
                    <label class="sr-only" for="date">Who will receive</label>
                    <base-input input-classes="form-control-sm"
                                class="mb-2 mr-sm-2"
                                placeholder="Who will receive this touch?"
                                v-b-tooltip.hover
                                title="Is this touch for only A+ Clients? Is this for everyone in your database?"
                                v-model="touchpointForm.who_receives">
                    </base-input>
                    <b-button size="sm" class="mb-2 mr-sm-2" variant="primary" @click="add">Add Touchpoint</b-button>
                  </b-form>
                </b-card-body>
                <strong class="mx-4">Example Touchpoints</strong>
                <b-table responsive small :items="exampleTouchpoints" :fields="fields">
                  <template #cell(completed)="data">
                    <i class="fas fa-check" v-if="data.item.completed"></i>
                  </template>
                </b-table>
                <strong class="mx-4">Your Database Plan</strong>
                <b-table responsive small :items="touchpoints" :fields="fields">
                  <template #cell(who_receives)="data">
                    <b-input v-if="editable == data.index" size="sm" placeholder="“Who will receive this touch?" v-model="data.item.who_receives"></b-input>
                    <span v-else>{{ data.item.who_receives}}</span>
                  </template>
                  <template #cell(touchpoint)="data">
                    <b-input v-if="editable == data.index" size="sm" v-model="data.item.touchpoint"></b-input>
                    <span v-else>{{ data.item.touchpoint }}</span>
                  </template>
                  <template #cell(date)="data">
                    <b-input v-if="editable == data.index" size="sm" type="date" v-model="data.item.date"></b-input>
                    <span v-else>{{ data.item.date }}</span>
                  </template>
                  <template #cell(completed)="data">
                    <b-form-checkbox v-if="editable == data.index" value="1" v-model="data.item.completed"></b-form-checkbox>
                    <span v-else><i class="fas fa-check" v-if="data.item.completed == 1"></i></span>
                  </template>
                  <template #cell(actions)="data">
                    <b-button-group v-if="editable === data.index" size="sm">
                      <b-button variant="success" @click="handleUpdate(data.item)"><i class="fa fa-check"></i> Save</b-button>
                      <b-button variant="danger" @click="cancel"><i class="fa fa-times"></i> Cancel</b-button>
                    </b-button-group>
                    <b-button-group v-else size="sm">
                      <b-button variant="primary" @click="handleEdit(data)"><i class="fa fa-edit"></i> Edit</b-button>
                      <b-button variant="danger" @click="handleDelete(data)"><i class="fa fa-trash"></i> Delete</b-button>
                    </b-button-group>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui';
import economicModelMixin from '@/mixins/economicModel-mixin';
import errorsMixin from '@/mixins/errors-mixin';
import LoadingPanel from '@/components/LoadingPanel';
import ObservedUpgradeOverlay from '@/views/Components/Overlays/ObservedUpgradeOverlay';
import UserpilotFlow from '@/views/Components/UserpilotFlow';

export default {
  mixins: [economicModelMixin, errorsMixin],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingPanel,
    ObservedUpgradeOverlay,
    UserpilotFlow
  },
  data: function() {
    return {
      sortBy: 'total_closings',
      sortDesc: true,
      loading: false,
      perPage: 11,
      currentPage: 1,
      year: new Date().getFullYear(),
      exampleTouchpoints: [
        {
          touchpoint: 'Email Newsletter',
          date: '1/2/' + new Date().getFullYear(),
          who_receives: 'Whole Database',
          completed: true,
        },
        {
          touchpoint: 'Invite Client to Client Event',
          date: '1/16/' + new Date().getFullYear(),
          who_receives: 'VIP Clients',
          completed: false,
        },
        {
          touchpoint: 'Hold Client Event at the Park',
          date: '1/20/' + new Date().getFullYear(),
          who_receives: 'VIP Clients',
          completed: false,
        }
      ],
      touchpoints: null,
      fields: [
        {
          key: 'touchpoint',
          label: 'Touchpoint'
        },
        {
          key: 'date',
          label: 'Date'
        },
        {
          key: 'who_receives',
          label: 'Who Receives'
        },
        {
          key: 'completed',
          label: 'Completed'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      touchpointForm: {
        year: this.year,
        touchpoint: null,
        completed: 0,
        who_receives: null,
        date: null
      },
      sourcesFields: [
        {
          key: 'source',
          label: 'Lead Source'
        },
        {
          key: 'total_closings'
        },
        {
          key: 'percent_of_business',
          label: '% of Business'
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      sources: null,
      sourceForm: {
        year: this.year,
        source: null,
        total_closings: null,
      },
      databaseForm: {
        id: null,
        year: this.year,
        size: 0,
        sales_count: 0,
        desired_sales: 0,
        increased_conversion_ratio: 0
      },
      editable: null,
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
    }
  },
  computed: {
    ...mapGetters({
      subBasic: 'observed/subBasic',
      subStandard: 'observed/subStandard',
      subPremium: 'observed/subPremium',
    }),
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    rows() {
      return this.sources ? this.sources.length : 0;
    },
    conversion_ratio() {
      return this.databaseForm.sales_count / this.databaseForm.size;
    },
    sumTotalClosings() {
      return this.sources ? this.sources.reduce(function (total, value) {
        return total + Number(value.total_closings);
      }, 0) : 0;
    },
    totalPercentOfBusiness() {
      let closedUnits = this.closedUnits;

      return this.sources ? this.sources.reduce(function (total, value) {
        return total + (Number(value.total_closings) / closedUnits * 100);
      }, 0) : 0;
    }
  },
  methods: {
    async getEconomicModel() {
      axios.get(this.userRoute + "/economic-model?year=" + this.year)
      .then(response => {
        this.economicModel = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getCos() {
      axios.get(this.userRoute + "/cost-of-sale?year=" + this.year)
      .then(response => {
        this.cos = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getTouchpoints() {
      axios.get(this.userRoute + "/touchpoints?year=" + this.year)
      .then(response => {
        this.touchpoints = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getLeadSources() {
      axios.get(this.userRoute + "/lead-sources?year=" + this.year)
      .then(response => {
        this.sources = response.data;
        this.loading = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getDatabase() {
      axios.get(this.userRoute + "/databases?year=" + this.year)
      .then(response => {
        this.databaseForm = response.data;
      })
      .catch(error => {
        this.error();
      });
    },
    async add() {
      axios.post(this.userRoute + "/touchpoints", this.touchpointForm)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getTouchpoints();
          this.touchpointForm.touchpoint = null;
          this.touchpointForm.completed = 0;
          this.touchpointForm.who_receives = null;
          this.touchpointForm.date = null;
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async addSources() {
      this.sourceForm.year = this.year;
      axios.post(this.userRoute + "/lead-sources", this.sourceForm)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getLeadSources();
          this.sourceForm.source = null;
          this.sourceForm.total_closings = null;
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async saveDatabase() {
      this.databaseForm.year = this.year;
      if(this.databaseForm.id) {
        axios.patch(this.userRoute + "/databases/" + this.databaseForm.id, this.databaseForm)
        .then(response => {
          swal.fire({
            title: `Success`,
            text: response.data,
            showConfirmButton: false,
            timer: 1750,
            icon: 'success'
          }).then(result => {
            this.getDatabase();
          });
        })
        .catch(error => {
          this.error(error);
        });
      } else {
        axios.post(this.userRoute + "/databases", this.databaseForm)
        .then(response => {
          swal.fire({
            title: `Success`,
            text: response.data,
            showConfirmButton: false,
            timer: 1750,
            icon: 'success'
          }).then(result => {
            this.getDatabase();
          });
        })
        .catch(error => {
          this.error(error);
        });
      }
    },
    handleEdit(data) {
      this.editable = data.index;
    },
    cancel() {
      this.editable = null;
    },
    async handleUpdate(touchpoint) {
      touchpoint.year = this.year;
      axios.patch(this.userRoute + "/touchpoints/" + touchpoint.id, touchpoint)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.editable = null;
          this.getTouchpoints();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async deleteData(data) {
      axios.delete(this.userRoute + '/touchpoints/' + data.item.id)
      .then(response => {
        this.touchpoints.splice(data.index, 1);
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleDelete(data) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteData(data);
          swal.fire({
            title: 'Deleted!',
            text: `Your touchpoint has been deleted.`,
            type: 'success',
            showConfirmButton: false,
            timer: 1500,
            icon: 'success'
          });
        }
      });
    },
    handleSourceDelete(data) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSource(data);
          swal.fire({
            title: 'Deleted!',
            text: `Your lead source has been deleted.`,
            type: 'success',
            showConfirmButton: false,
            timer: 1500,
            icon: 'success'
          });
        }
      });
    },
    async deleteSource(data) {
      axios.delete(this.userRoute + '/lead-sources/' + data.item.id)
      .then(response => {
        this.sources.splice(data.index, 1);
      })
      .catch(error => {
        this.error(error);
      });
    },
    mounted() {
      document.title = this.year + ' Lead Gen Model';
    }
  },
  created() {
    this.loading = true;
    this.getEconomicModel();
    this.getCos();
    this.getTouchpoints();
    this.getLeadSources();
    this.getDatabase();
  },
  watch: {
    year(to, from) {
      document.title = to + ' Lead Gen Model';
      this.getTouchpoints();
      this.getLeadSources();
      this.getDatabase();
    }
  }
};
</script>